import remitoTemplatesService from "../../services/remitoTemplates";

const state = {
  templateActivo: null,
  templates: [],
  configDefault: null,
};

const mutations = {
  SET_TEMPLATE_ACTIVO(state, template) {
    state.templateActivo = template;
  },
  SET_TEMPLATES(state, templates) {
    state.templates = templates;
  },
  SET_CONFIG_DEFAULT(state, config) {
    state.configDefault = config;
  },
};

const actions = {
  async getDatosEmpresa(_, idEmpresa) {
    const res = await remitoTemplatesService.getDatosEmpresa(idEmpresa);
    return res.data || res;
  },

  async getTemplateActivo({ commit }, idEmpresa) {
    const res = await remitoTemplatesService.getTemplateActivo(idEmpresa);
    const template = res.data;
    if (template) {
      commit("SET_TEMPLATE_ACTIVO", template);
      return { data: template, mensaje: res.mensaje };
    }
    throw new Error("Template no encontrado");
  },

  async getTemplateById({ commit }, id) {
    const res = await remitoTemplatesService.getTemplateById(id);
    const template = res.data || res;
    if (template) {
      commit("SET_TEMPLATE_ACTIVO", template);
      return { data: template, mensaje: res.mensaje };
    }
    throw new Error("Template no encontrado");
  },

  async listarTemplates({ commit }, idEmpresa) {
    const res = await remitoTemplatesService.listarTemplates(idEmpresa);
    const templates = res.data || [];
    commit("SET_TEMPLATES", templates);
    return templates;
  },

  async crearTemplate(_, payload) {
    const res = await remitoTemplatesService.crearTemplate(payload);
    return res.data || res;
  },

  async actualizarTemplate(_, { id, payload }) {
    const res = await remitoTemplatesService.actualizarTemplate(id, payload);
    return res.data || res;
  },

  async eliminarTemplate(_, id) {
    const res = await remitoTemplatesService.eliminarTemplate(id);
    return res.data || res;
  },

  async duplicarTemplate(_, { id, nuevoNombre }) {
    const res = await remitoTemplatesService.duplicarTemplate(id, nuevoNombre);
    return res.data || res;
  },

  async getConfigDefault({ commit }) {
    const res = await remitoTemplatesService.getConfigDefault();
    const config = res.data || res;
    commit("SET_CONFIG_DEFAULT", config);
    return config;
  },

  async uploadLogo(_, { idEmpresa, file }) {
    const res = await remitoTemplatesService.uploadLogo(idEmpresa, file);
    return res.data || res;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
